import { SessionDialog } from '@parkhub/parkhub-ui';
import React, { Component, Fragment } from 'react';
import { withCookies } from 'react-cookie';
import { Snackbar } from 'react-md';
import { connect } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { checkAuth, setAuthUser } from '../actions/authUser.action';
import { setDialogVisibility } from '../actions/dialog.action';
import { addToast, dismissToast } from '../actions/toast.action';
import { setVisibility } from '../actions/wizard.action';
import { ErrorModal, LandingPage } from '../components/index';
import { getAuthUser, getSessionTime, refreshSession, signOut } from '../utils';
import './App.scss';

class App extends Component {
  state = {
    sessionModalVisible: false
  }

  componentDidMount = () => {
    this.unlisten = this.props.history.listen(() => {
      this.onRouteChanged();
    });

    this.checkLoggedIn();
  }

  componentWillUnmount() {
    this.unlisten();
    clearTimeout(this.timer);
  }

  onRouteChanged() {
    this.checkLoggedIn();
  }

  checkLoggedIn = () => {
    if (!checkAuth()) {
      window.location.replace(`${process.env.REACT_APP_SUITE_URL}signin?redirectUrl=${window.location.href}`);
    } else {
      this.props.setAuthUser(getAuthUser());
      this.restart();
    }
  }

  dismissToast = () => {
    const [, ...toastList] = this.props.toastList;

    this.props.dismissToast({ toasts: toastList });
  };

  hide = () => {
    this.setState({ sessionModalVisible: false });
  }

  show = () => {
    this.setState({ sessionModalVisible: true });
  }

  restart = () => {
    refreshSession()
      .then(() => {
        clearInterval(this.timer);

        const checkSessionTimeout = () => {
          if (!checkAuth()) {
            signOut();

          } else {
            const minutes = getSessionTime();

            if (minutes > 1440) {
              this.hide();
              signOut('?expired=true');

            } else if (minutes > 1438 && minutes < 1440) {
              this.show();
            }
          }
        };

        this.timer = setInterval(checkSessionTimeout, 10000);
      });
  }

  render() {
    const { autohideToast, autohideTimeout, toastList, errorDialog } = this.props;

    return (
      <BrowserRouter>
        <Fragment>
          <LandingPage />
          <Snackbar
            id='snackbar'
            toasts={toastList}
            autohide={autohideToast}
            onDismiss={this.dismissToast}
            autohideTimeout={autohideTimeout}
          />
          <ErrorModal
            error={errorDialog.error}
            visible={errorDialog.visible}
          />
          <SessionDialog
            onHide={this.hide}
            visible={this.state.sessionModalVisible}
            onContinue={this.restart}
            onTimeExpire={() => signOut('?expired=true')}
            onSignOut={signOut}
          />
        </Fragment>
      </BrowserRouter>
    );
  }
}

const mapStateToProps = state => ({
  errorDialog: state.errorDialog,
  toastList: state.toast.toasts,
  autohideToast: state.toast.autohide,
  autohideTimeout: state.toast.autohideTimeout,
  authUser: state.session.authUser
});

export default withCookies(
  connect(
    mapStateToProps,
    {
      setVisibility,
      addToast,
      dismissToast,
      setAuthUser,
      setDialogVisibility
    }
  )(App)
);



// WEBPACK FOOTER //
// ./src/App/App.jsx